import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchOrderByInvoiceNumber } from '../../Services/profileServices';
import { Container, Row, Col, Card, Image, Spinner } from 'react-bootstrap';
import { Image_URL } from '../../config/config';
import './orderInformation.css';

const OrderInformation = () => {
  const { invoiceNumber } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const fetchOrder = async () => {
      console.log("Fetching order for Invoice Number:", invoiceNumber);
      const orderData = await fetchOrderByInvoiceNumber(invoiceNumber);
      console.log("Fetched Order Data:", orderData);
      setOrder(orderData[0]);
    };

    fetchOrder();
  }, [invoiceNumber]);

  if (!order) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  const billingDetails = order.BillingDetails?.[0] ?? {};

  return (
    <Container className="my-5">
      <h2 className="mb-4 information-header">Order Information</h2>
      <hr />
      <Row>
        <Col md={6}>
          <Card className="bg-transparent border-0">
            <Card.Body>
              <h5 className="mb-4">Billing Information</h5>
              <div className="mb-3">
                <p className="mb-2">
                  <strong>Name:</strong> <span className="text-muted">{billingDetails.FirstName || "N/A"} {billingDetails.LastName || ""}</span>
                </p>
                <p className="mb-2">
                  <strong>Email:</strong> <span className="text-muted">{billingDetails.Email || "N/A"}</span>
                </p>
                <p className="mb-2">
                  <strong>Contact Number:</strong> <span className="text-muted">{billingDetails.Phone || "N/A"}</span>
                </p>
                <p className="mb-2">
                  <strong>Address:</strong> <span className="text-muted">{billingDetails.Address1 || "N/A"}, {billingDetails.Address2 || ""}, {billingDetails.City || ""}, {billingDetails.Country || ""}, {billingDetails.PostalCode || ""}</span>
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card className="bg-transparent border-0">
            <Card.Body>
              {order.OrderDetails && order.OrderDetails.length > 0 ? (
                <>
                  {order.OrderDetails.map((item) => (
                    <div key={item.Id} className="order-item mb-3 pb-3">
                      <Row className="gx-2 align-items-center">
                        <Col xs={3}>
                          <div className="image-wrapper">
                            <Image
                              src={`${Image_URL}products/thumbnails/${item.Sources}`}
                              alt={item.Title}
                              className="product-image rounded"
                              style={{ width: '100px', height: '146px', objectFit: 'cover' }}
                            />
                          </div>
                        </Col>
                        <Col xs={9}>
                          <div className="item-details ps-1">
                            <h6 className="mb-1">{item.Title || "N/A"}</h6>
                            <p className="mb-1 small text-muted">SKU: #{item.ProductId || "N/A"}</p>
                            <Row className="g-0 align-items-center mt-1">
                              <Col xs={12}>
                                <div className="mb-1">
                                  <span className="small text-muted">Qty: {item.Qty || "N/A"}</span>
                                </div>
                                <div className="mb-1">
                                  <span className="small text-muted">Variant: {item.Color || "N/A"}</span>
                                </div>
                                <div>
                                  <span className="small text-muted">Price: Rs. {item.UnitPrice || "N/A"}</span>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ))}

                  <div className="order-summary mt-4">
                    <Row className="mb-2">
                      <Col>Subtotal</Col>
                      <Col className="text-end text-muted">Rs. {order.OrderAmount}</Col>
                    </Row>
                    <Row className="mb-2">
                      <Col>Discount</Col>
                      <Col className="text-end text-muted">Rs. {order.Discount || 0}</Col>
                    </Row>
                    <Row className="mb-2">
                      <Col>Shipping</Col>
                      <Col className="text-end text-muted">Rs. {order.Shipping || 0}</Col>
                    </Row>
                    <Row className="fw-bold pt-2 border-top mt-2">
                      <Col>Total</Col>
                      <Col className="text-end">Rs. {order.TotalAmount || order.OrderAmount}</Col>
                    </Row>
                  </div>
                </>
              ) : (
                <p className="text-muted text-center mb-0">No order details available.</p>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default OrderInformation;